<template>
  <div class="w-full">
    <vs-card
      id="ehs-donut-loading"
      class="vs-con-loading__container px-2 widget-card altura"
      style="position: relative"
    >
      <div @click="filterFullTable">
        <vs-row>
          <vs-col>
            <char-header :title="$t('ehs_status')" class="mb-2"></char-header>
          </vs-col>
        </vs-row>
      </div>

      <vs-row>
        <vs-col>
          <div class="body-card-widget">
            <apexcharts
              class=""
              type="donut"
              height="250%"
              style="max-height: 270px"
              :options="chartOptions"
              :series="series"
              @dataPointSelection="filterTable"
            ></apexcharts>
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import dashboardTV from '@/http/requests/dashboard'
import CharHeader from '../components/CharHeader.vue'
import loading from '@/mixins/Loading.js'

export default {
  name: 'ehs-donut',
  mixins: [loading],
  props:{
    refresh:{
      type:Boolean,
      default:false,
    }
  },
  components: {
    apexcharts: VueApexCharts,
    CharHeader,
  },
  computed: {
    isLoading() {
      return this.loading.ehs_donut
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('ehs-donut-loading')
      } else {
        this.closeLoading('ehs-donut-loading')
      }
    },
  },
  data: function () {
    return {
      loading: {
        ehs_donut: false,
      },
      series: [],
      chartOptions: {
        labels: [],
        chart: {
          id: 'ehs',
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  label: '',
                  formatter: function (w) {
                    let total = 0
                    let number
                    let numberOut = 0
                    w.globals.seriesTotals.forEach((element) => {
                      total = total + parseInt(element)
                    })
                    let indice =
                      w.globals.seriesNames.indexOf('Not in Compliance')

                    number = total - parseInt(w.globals.seriesTotals[indice])
                    if (number != NaN) {
                      numberOut = Math.round((number * 100) / total)
                    }
                    if (indice == -1) numberOut = 100
                    return numberOut + '%'
                  },
                },
                value: {
                  show: true,
                  fontSize: '30px',
                },
                name: {
                  show: false,
                },
              },
            },
          },
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          marker: {
            show: false,
          },
        },
      },
      ehsData: null,
      colors: [],
      ehsSelect: null,
    }
  },
  methods: {
    getStatusEHS() {
      this.loading.ehs_donut = true
      dashboardTV
        .ehsStatus()
        .then((res) => {
          this.ehsData = res.data.data
          this.setStatusEHS()
        })
        .catch((err) => {
          console.log(err)
          this.loading.ehs_donut = false
        })
    },

    setStatusEHS() {
      if (this.ehsData.length == 0) {
        this.series = [1]
        this.chartOptions.labels = ['NO INFO']
        this.colors = ['#626262']
        this.resertDonut()
      } else {
        for (let i = 0; i < this.ehsData.length; i++) {
          this.chartOptions.labels[i] = this.ehsData[i].status_name
          this.series[i] = parseInt(this.ehsData[i].amount)
          this.colors[i] = this.ehsData[i].status_color
        }
        this.resertDonut()
      }
    },
    resertDonut() {
      ApexCharts.exec('ehs', 'updateOptions', {
        fill: {
          colors: this.colors,
        },
        labels: this.chartOptions.labels,
        series: this.series,
      })
      this.loading.ehs_donut = false
    },
    filterTable(event, chartContext, config) {
      let data = this.ehsData.find(
        (el) => el.status_name === config.w.config.labels[config.dataPointIndex]
      )
      this.$emit('click', { statusId: data.status_id })
    },
    filterFullTable(event, chartContext, config) {
      this.$emit('click', { statusId: null })
    },
  },
  mounted() {
    this.getStatusEHS()
    if(this.refresh === true){
      var v = this
      setInterval(function () {
        v.getStatusEHS()
      }, process.env.VUE_APP_CHART_RELOAD_TIME)
    }
  },
}
</script>
<style>
.card-style {
  height: 80vh;
}
</style>
